export const USDC_CURRENCY_SUFFIX = 'USDC'
